import * as React from 'react';
import { Link } from 'react-router-dom';

import './ManageOverview.scss';
import { User } from 'src/store/user/types';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { colorError } from 'src/variables';
import Footer from 'src/components/layout/Footer/Footer';

interface Props {
  match: any;

  user: User;
}

class ManageOverview extends React.Component<Props> {
  public render() {
    const { match, user } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <ul className="col-lg-6 centered">
            <li>
              <Link to={`${match.url}/user`}>
                <div className="box_item">
                  <span>Betriebslogo</span>
                </div>
              </Link>
            </li>
            {user.role.canManageSections && (
              <li>
                <Link to={`${match.url}/sections`}>
                  <div className="box_item">
                    <span>Themenbereiche</span>
                  </div>
                </Link>
              </li>
            )}
            {user.role.canManageSaisons && (
              <li>
                <Link to={`${match.url}/seasons`}>
                  <div className="box_item">
                    <span>Saisonen</span>
                  </div>
                </Link>
              </li>
            )}
            {(user.role.canCreateEvents || user.role.canUpdateEvents) && (
              <li>
                <Link to={`${match.url}/events`}>
                  <div className="box_item">
                    <span>Veranstaltungen</span>
                  </div>
                </Link>
              </li>
            )}
            {(user.role.canUpdateUser || user.role.canDeleteUser) && (
              <li>
                <Link to={`${match.url}/users`}>
                  <div className="box_item">
                    <span>Benutzerverwaltung</span>
                  </div>
                </Link>
              </li>
            )}
            {user.username === 'superadmin' && (
              <li>
                <Link to={`${match.url}/logs`}>
                  <div className="box_item">
                    <span>Logs</span>
                  </div>
                </Link>
              </li>
            )}
            {user.username === 'superadmin' && (
              <li>
                <Link to={`${match.url}/closure`}>
                  <div className="box_item" style={{ border: '2px solid ' + colorError }}>
                    <span>Jahresabschluss</span>
                  </div>
                </Link>
              </li>
            )}
          </ul>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }: ApplicationState) => ({
  user: auth.data
});

export default connect(mapStateToProps)(ManageOverview);



// WEBPACK FOOTER //
// ./src/pages/Management/ManageOverview.tsx